import { StatusBadge, type StatusTone } from '@/components/ui/badge';
import { channelLabel } from '@/lib/utils';

const CHANNEL_TONE: Record<string, StatusTone> = { sftp_edi: 'cyan', website: 'amber' };

// Supplier dispatch channel badge: EDI / Email/SMS / Website.
export function ChannelChip({ channel }: { channel: string | undefined | null }) {
  if (!channel) return <span className="chip chip--ghost invisible">—</span>;
  return (
    <StatusBadge tone={CHANNEL_TONE[channel] ?? 'green'} className="whitespace-nowrap">
      {channelLabel(channel)}
    </StatusBadge>
  );
}
